/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../../shared/qrequest";
import BaseCom from "../../BaseCom";
import FormInput from "../../FormInput";
import L from "../../Lang";
import Totals from "../Totals";


export default class ACH extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                processType: 'bk',
                bkAccountID: null
            },
            list: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.setState({ info: { ...this.state.info, bankHolderName: this.props.session.firstName + ' ' + this.props.session.lastName }});
    }

    fetchJWT = async () => {
        try {
            let j = await qreq.getAsync('/api/payment/jwt');
            if (j.item) {
                this.setState({ jwt: j.item, info: { ...this.state.info, jwt: j.item } });
                this.pollCardinal(j.item, this.state.info.cardNumber);
                return j.item;
            }
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submit = async (e, sessionID) => {
        if(!sessionID) sessionID = this.state.cardinalSessionID;
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let info = { ...this.state.info };
            info.amount = this.props.session.amount;
            info.sessionID = sessionID;
            info.sid = this.props.session.sid;
            info.jwt = this.state.jwt;
            if(!info.sessionID) {
                this.alert('Session has expired. Will reload payment process.');
                window.location.reload();
                return;
            }
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    link = () => {
        //TODO
    }


    render() {
        return <form onSubmit={this.submit}>
            

            <div className="bg-white p-3 mb-3 rounded">
                <p><L>Pay securely using your checking account</L></p>
                {this.state.list?.length > 0 ? <ul>
                    <li>TODO</li>
                </ul> : <p className="text-muted"><L>Please start by linking your first account by clicking the button below.</L></p>}
                {!this.state.showLinkBankAccount && <div>
                    <button type="button" className="btn btn-primary" onClick={() => this.setState({ showLinkBankAccount: true })}><L>Link Bank Account</L></button>
                </div>}
                {this.state.showLinkBankAccount && <div>
                    <FormInput model={this.state.info} name="holderName" label="Account Holder Name" placeholder="John Doe" required />
                    <FormInput model={this.state.info} name="accountNumber" label="Account Number" placeholder="#########" required />
                    <FormInput model={this.state.info} name="routingNumber" label="Routing Number" placeholder="#########" required />
                    <div>
                    <button type="button" className="btn btn-primary" onClick={this.link}><L>Link Account</L></button>
                    <button type="button" className="btn" onClick={() => this.setState({ showLinkBankAccount: false })}><L>Cancel Linking Account</L></button>
                </div>
                </div>}
            </div>


            <Totals session={this.props.session} />
            <div className="d-grid my-2">
                <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting || !this.state.info.bkAccountID}>
                    {this.state.submitting ? <L>Processing please wait...</L>
                        : <L>Complete Payment</L>}
                </button>
                {!this.state.submitting && <button type="button" className="btn btn-lg" onClick={this.props.onCancel}>
                    <L>Select a different Payment Method</L>
                </button>}
            </div>
        </form>;
    }
}